<script lang="ts">
    import {onMount} from "svelte";
    import AuthStateView from "../auth/AuthStateView.svelte";
    import HeaderLogoView from "./HeaderLogoView.svelte";


    onMount(() => {

    });


</script>
<div class="header-pc-view">
    <div class="left-area">
        <div class="logo-area">
            <HeaderLogoView
                    src="/img/logo.png"
            />
        </div>

        <div id="header-left-portal-target"></div>
        <div id="header-page-portal-target"></div>
    </div>
    <div class="center-area">

    </div>
    <div class="right-area">
        <div id="header-right-portal-target"></div>
        <AuthStateView/>

    </div>


</div>
<style lang="scss">
    .header-pc-view {
        background: var(--header-background);
        color: var(--header-text-color);
        height: var(--header-height);


        display: flex;
        align-items: center;

        .left-area {
            display: flex;
            align-items: center;
            height: 100%;
            gap: 16px;

            .logo-area {
                padding-left: 12px;
                padding-right: 12px;
                height: 100%;

                display: flex;
                align-items: center;
                justify-content: flex-start;

                font-size: 24px;
                letter-spacing: 0.1em;


                > a {
                    display: flex;
                    align-items: center;
                    justify-content: center;


                    > .logo-image {
                        display: inline-flex;
                        align-items: center;


                        &.normal {
                            display: inline-flex;
                        }

                        &.animated {
                            display: none;
                        }

                        > :global(.image-view) {
                            height: 36px;
                            padding-bottom: 3px;
                            max-width: 100%;
                        }
                    }


                }

                &:hover {
                    > a {

                        > .logo-image {
                            &.normal {
                                display: none;

                            }

                            &.animated {
                                display: inline-flex;
                            }

                        }

                    }
                }

            }
        }

        .center-area {
            flex-grow: 1;
        }

        .right-area {


            padding-right: 12px;
            display: flex;
            align-items: center;
            gap: 32px;

        }


    }
</style>